module.exports = __webpack_public_path__ + "static/media/gas-station-crop-mobile.9e2e81e1.png";